<template>
  <PSIndexServiceState />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
